import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="w-full bg-teal px-5 py-20 text-center sm:py-24" data-id="element-87" data-mp="3ucndvrnypfti">
      <div className="mx-auto max-w-3xl" data-id="element-88" data-mp="3uei33i69nu3e">
        <h2 className="text-2xl font-extrabold leading-tight tracking-tight text-cream sm:text-4xl" data-id="element-89" data-mp="c70yncel7jpm">
          Ready to Teach Your First Class with Confidence?
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-sage-tint/90 sm:text-lg" data-id="element-90" data-mp="m4yk5s52b2ej">
          Join the teachers building their first beginner classes with a system that's ready when
          they are.
        </p>
        <div className="mt-9" data-id="element-91" data-mp="vv1d5sc6ogcv">
          <CTAButton data-id="element-92" data-mp="vtym9kev2dwy" />
          <p className="mt-5 text-sm text-sage-tint/80" data-id="element-93" data-mp="vwkrhdea4hc0">
            Instant Access · 7-Day Guarantee · One-Time Payment of $19
          </p>
        </div>
      </div>
    </section>;
}